import React, { PropsWithChildren } from 'react'
import { AuthProvider } from 'providers/auth'
import { ApplicationProvider } from 'providers/application'
import { ProjectProvider } from 'providers/project'
import { SocketProvider } from 'providers/socket'
import { NotificationsProvider } from 'providers/notifications'
import { HubsDataProvider } from 'providers/hubs'

export const AppProviders: React.FC<PropsWithChildren> = ({ children }) => (
  <AuthProvider>
    <ApplicationProvider>
      <SocketProvider>
        <NotificationsProvider>
          <ProjectProvider>
            <HubsDataProvider>{children}</HubsDataProvider>
          </ProjectProvider>
        </NotificationsProvider>
      </SocketProvider>
    </ApplicationProvider>
  </AuthProvider>
)
